import moment from 'moment';

const DAY_KEY_FORMAT = 'YYYY-MM-DD';

export default class dateUtils {
  static parseUTCEpoch(time) {
    return time !== null
      ? new Date(time + new Date(time).getTimezoneOffset() * 60 * 1000)
      : null;
  }

  static getUTCEpoch(time) {
    return time
      ? time.valueOf() - new Date(time).getTimezoneOffset() * 60 * 1000
      : null;
  }

  // Day key for an epoch holding a local wall clock stored as UTC, which is how
  // the API returns event times. Reading it in UTC gives the day at the venue
  // rather than the day in whichever zone the browser happens to be in. Absent
  // times key to null, since moment reads them as the current day.
  static utcDayKey(time) {
    return time == null ? null : moment.utc(time).format(DAY_KEY_FORMAT);
  }

  // Day key for a Date built from local calendar fields, such as a grid cell.
  static localDayKey(date) {
    return date == null ? null : moment(date).format(DAY_KEY_FORMAT);
  }
}
